import { useQuery } from '@tanstack/react-query';
import type { WbgtTimeline } from '@heat-pwa/types';

const API_BASE = import.meta.env.VITE_API_BASE ?? '';
const REFETCH_MS = 60 * 60 * 1000;

async function fetchTimeline(): Promise<WbgtTimeline> {
  const res = await fetch(`${API_BASE}/api/wbgt/timeline`);
  if (!res.ok) throw new Error(`wbgt timeline fetch failed: ${res.status}`);
  return (await res.json()) as WbgtTimeline;
}

export function useWbgtTimelineQuery() {
  return useQuery({
    queryKey: ['wbgt', 'timeline'],
    queryFn: fetchTimeline,
    refetchInterval: REFETCH_MS,
    staleTime: REFETCH_MS / 2,
  });
}
